"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var exposed_hooks_1 = require("@widget-editor/widget-editor/lib/exposed-hooks");

var selectors_1 = require("@widget-editor/shared/lib/modules/theme/selectors");

var selectors_2 = require("@widget-editor/shared/lib/modules/end-user-filters/selectors");

var selectors_3 = require("@widget-editor/shared/lib/modules/editor/selectors");

var constants = __importStar(require("../constants"));

var fields_1 = __importDefault(require("../services/fields"));

var ChartCommon =
/*#__PURE__*/
function () {
  function ChartCommon(store) {
    _classCallCheck(this, ChartCommon);

    this.store = store;
  }

  _createClass(ChartCommon, [{
    key: "isDate",
    value: function isDate() {
      var _a;

      var configuration = this.store.configuration;
      return ((_a = configuration.category) === null || _a === void 0 ? void 0 : _a.type) === 'date';
    }
  }, {
    key: "resolveName",
    value: function resolveName(axis) {
      var _a, _b, _c;

      var _this$store = this.store,
          configuration = _this$store.configuration,
          editor = _this$store.editor;
      var xAxisTitle = configuration.xAxisTitle,
          yAxisTitle = configuration.yAxisTitle;

      if (axis === 'x' && xAxisTitle) {
        return xAxisTitle;
      }

      if (axis === 'y' && yAxisTitle) {
        return yAxisTitle;
      }

      var fieldIdentifier;

      if (axis === 'x') {
        fieldIdentifier = 'category';
      } else if (axis === 'y') {
        fieldIdentifier = 'value';
      } else {
        fieldIdentifier = 'color';
      }

      var fieldName = (_a = configuration[fieldIdentifier]) === null || _a === void 0 ? void 0 : _a.name;
      var field = (_b = editor.fields) === null || _b === void 0 ? void 0 : _b.find(function (f) {
        return f.columnName === fieldName;
      });
      var name = ((_c = field === null || field === void 0 ? void 0 : field.metadata) === null || _c === void 0 ? void 0 : _c.alias) ? field.metadata.alias : fieldName;

      if (axis === 'y' && configuration.aggregateFunction) {
        return "".concat(name, " (").concat(configuration.aggregateFunction, ")");
      }

      return name;
    }
  }, {
    key: "resolveFormat",
    value: function resolveFormat(axis) {
      var _a, _b;

      var _this$store2 = this.store,
          configuration = _this$store2.configuration,
          widgetData = _this$store2.editor.widgetData;

      if (axis === 'y') {
        return configuration.format || 's';
      }

      if (((_a = configuration.category) === null || _a === void 0 ? void 0 : _a.type) === 'date') {
        var timestamps = widgetData.map(function (d) {
          return +new Date(d.x);
        });
        var min = Math.min.apply(Math, _toConsumableArray(timestamps));
        var max = Math.max.apply(Math, _toConsumableArray(timestamps));

        if (Number.isNaN(min) || Number.isNaN(max)) {
          return null;
        }

        var day = 1000 * 60 * 60 * 24;
        var month = 31 * day;
        var year = 12 * month;

        if (max - min <= 2 * day) {
          return '%H:%M';
        } else if (max - min <= 2 * month) {
          return '%d %b';
        } else if (max - min <= 2 * year) {
          return '%b %Y';
        }

        return '%Y';
      } else if (((_b = configuration.category) === null || _b === void 0 ? void 0 : _b.type) === 'number') {
        var allIntegers = widgetData.length && widgetData.every(function (d) {
          return parseInt(d.x, 10) === d.x;
        });

        if (allIntegers) {
          return 'd';
        }
      }

      return '.2f';
    }
  }, {
    key: "resolveScheme",
    value: function resolveScheme() {
      var scheme = selectors_1.selectScheme(this.store);
      return exposed_hooks_1.getLocalCache().adapter.getSerializedScheme(scheme);
    }
  }, {
    key: "resolveSignals",
    value: function resolveSignals() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var dataset, endUserFilters, fields, fieldService, promises;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataset = this.store.editor.dataset;
                endUserFilters = selectors_2.selectEndUserFilters(this.store);
                fields = selectors_3.selectFields(this.store);
                fieldService = new fields_1["default"](dataset, fields);
                _context2.next = 6;
                return endUserFilters.map(function (fieldName) {
                  return __awaiter(_this, void 0, void 0,
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee() {
                    var _a, _b, field, type, signal, options, _ref, min, max, _ref2, _min, _max;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            field = fields.find(function (f) {
                              return f.columnName === fieldName;
                            });
                            type = (_b = (_a = constants.ALLOWED_FIELD_TYPES.find(function (type) {
                              return type.name === field.type;
                            })) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'string';
                            signal = {
                              name: field.metadata && field.metadata.alias ? field.metadata.alias : field.columnName,
                              value: null,
                              bind: {}
                            };
                            _context.t0 = type;
                            _context.next = _context.t0 === 'string' ? 6 : _context.t0 === 'number' ? 12 : _context.t0 === 'date' ? 20 : 28;
                            break;

                          case 6:
                            _context.next = 8;
                            return fieldService.getColumnValues(field);

                          case 8:
                            options = _context.sent;
                            signal.value = options.length ? options[0] : null;
                            signal.bind = {
                              input: 'select',
                              options: options
                            };
                            return _context.abrupt("break", 28);

                          case 12:
                            _context.next = 14;
                            return fieldService.getColumnMinAndMax(field);

                          case 14:
                            _ref = _context.sent;
                            min = _ref.min;
                            max = _ref.max;
                            signal.value = min;
                            signal.bind = {
                              input: 'range',
                              min: min,
                              max: max,
                              step: 0.1
                            };
                            return _context.abrupt("break", 28);

                          case 20:
                            _context.next = 22;
                            return fieldService.getColumnMinAndMax(field);

                          case 22:
                            _ref2 = _context.sent;
                            _min = _ref2.min;
                            _max = _ref2.max;
                            signal.value = new Date(_min).toISOString().split('T')[0];
                            signal.bind = {
                              input: 'date',
                              min: new Date(_min).toISOString().split('T')[0],
                              max: new Date(_max).toISOString().split('T')[0]
                            };
                            return _context.abrupt("break", 28);

                          case 28:
                            ;
                            return _context.abrupt("return", signal);

                          case 30:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                });

              case 6:
                promises = _context2.sent;
                return _context2.abrupt("return", Promise.all(promises)["catch"](function () {
                  return [];
                }));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "resolveEndUserFiltersTransforms",
    value: function resolveEndUserFiltersTransforms() {
      var endUserFilters = selectors_2.selectEndUserFilters(this.store);
      var fields = selectors_3.selectFields(this.store);

      if (!endUserFilters.length) {
        return [];
      }

      return [{
        type: 'filter',
        expr: endUserFilters.reduce(function (res, fieldName, index) {
          var _a, _b;

          var field = fields.find(function (f) {
            return f.columnName === fieldName;
          });
          var signal = field.metadata && field.metadata.alias ? field.metadata.alias : field.columnName;
          var type = (_b = (_a = constants.ALLOWED_FIELD_TYPES.find(function (type) {
            return type.name === field.type;
          })) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'string';
          return "".concat(res).concat(index > 0 ? ' && ' : '').concat(type === 'date' ? "toDate(datum.".concat(fieldName, ")") : "datum.".concat(fieldName), " === ").concat(type === 'date' ? "toDate(".concat(signal, ")") : signal);
        }, '')
      }];
    }
  }]);

  return ChartCommon;
}();

exports["default"] = ChartCommon;